
import { defineComponent, onBeforeMount, PropType } from 'vue'

const TABS = [
    { id: 'general', name: 'Основная информация' },
    { id: 'cargo-information', name: 'Информация о грузе' },
    { id: 'payment', name: 'Оплата' },
    { id: 'stops', name: 'Отправитель / Остановки' }
]

export default defineComponent({
    props: {
        value: {
            type: String,
            default: null,
        },
        statusId: {
            type: Number,
            default: null
        },
        invoiceFiles: {
            type: Array as PropType<File[]>,
            default: () => []
        },
        certificateFiles: {
            type: Array as PropType<File[]>,
            default: () => []
        }
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const isTabSelected = (tab: { id: string }) => {
            if (!props.value) return false
            return props.value === tab.id
        }

        const selectTab = (tab: { id: string }) => {
            if (isTabSelected(tab)) return
            emit('update:value', tab.id)
            emit('change', tab.id)
        }

        const checkFiles = () => {
            if(props.invoiceFiles.length || props.certificateFiles.length) {
                TABS.push({ id: 'files', name: 'Файлы' })
            }
        }

        const checkCarrier = () => {
            if (props.statusId === 8) {
                TABS.push({ id: 'car', name: 'Оформление машины' })
            }
        }

        onBeforeMount(() => {
            checkCarrier()
            checkFiles()
        })

        return {
            TABS,
            isTabSelected,
            selectTab
        }
    }
})
